import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'


class DetailBloc {

    detailChannel = new Subject();
    updateChannel = new Subject();
    rowtableChannel = new Subject();
    exportChannel = new Subject();
    employeeListChannel = new Subject();
    repository = new DetailRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.updateChannel.next({status: apiResponse.INITIAL})
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.exportChannel.next({status: apiResponse.INITIAL})
        this.employeeListChannel.next({status: apiResponse.INITIAL})
    }

    fetchListPresensi = async (query, cancelToken) => {
        this.rowtableChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchListPresensi(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchUpdatePresensi = async (query) => {
        this.updateChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchUpdatePresensi(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
    fetchExport = async (query) => {
        this.exportChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }

    fetchEmployeeList = async (query) => {
        try {
            this.employeeListChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployeeList(query).then((result) => {
                this.employeeListChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeListChannel.next({status: apiResponse.ERROR, data: error})
            })  
        } catch (error) {
            console.log('rxjs', error)
        }
    }
}

export default DetailBloc